// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__7Y0pO","wrapper":"styles_wrapper__xx83G","controls":"styles_controls__c+pnw","keepRatioRow":"styles_keepRatioRow__TSKKK","buttons":"styles_buttons__OYk2Y"};